
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/river-3-series-portable-power-station",
      function () {
        return require("private-next-pages/river-3-series-portable-power-station/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/river-3-series-portable-power-station"])
      });
    }
  